import {method} from './core';

export function crmCountUnread(data) {
  return method('crm/count', data);
}



// WEBPACK FOOTER //
// ./src/helpers/api/crm.js